// extracted by mini-css-extract-plugin
module.exports = {"articles":"SectionNews_articles__e2Vlq","article":"SectionNews_article__n2_lp"};